export function isAbortError(error) {
  const cause = error?.error ?? error?.cause ?? error;
  return cause?.name === 'AbortError' || cause?.code === 20;
}

export function getInternalApiOptions(body, method = 'POST') {
  return {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
}
